"use client";

import { useState } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { Dialog, DialogPanel, Disclosure, DisclosureButton, DisclosurePanel, Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { Bars3Icon, XMarkIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import logo from "../assets/images/logo.jpg";

// subName is used for mobile layout since it has a different font
const navigation = [
  { name: "HOME", subName: "Home", to: "/" },
  { name: "SERVICES", subName: "Services", to: "/services" },
];

export default function Example() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return (
    <header className="absolute inset-x-0 top-0 z-50">
      <div className="mx-auto max-w-7xl">
        <div className="px-6 pt-6 lg:max-w-2xl lg:pl-8 lg:pr-0">
          <nav
            aria-label="Global"
            className="font-chakra_petch_sm tracking-[0.25em] [font-stretch:110%] font-bold flex items-center justify-between lg:justify-start"
          >
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">HighTide Roofing</span>
              <img alt="HighTide Roofing" src={logo} className="h-8 w-auto" />
            </Link>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(true)}
              className="-m-2.5 rounded-md p-2.5 text-gray-700 lg:hidden"
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon aria-hidden="true" className="size-6" />
            </button>
            <div className="hidden lg:ml-12 lg:flex lg:gap-x-14">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.to}
                  className="text-sm/6 font-bold text-gray-900 hover:text-gray-500"
                >
                  {item.name}
                </Link>
              ))}
              {/* separated contact from navigation.map() for ability to smooth scroll to /#FreeQuote with HashLink, same is done to the mobile layout below */}
              <Popover className="relative">
                {({ open, close }) => (
                  <div
                    onMouseEnter={(e) => {
                      const button = e.currentTarget.querySelector('button');
                      if (!open && button) button.click();
                    }}
                    onMouseLeave={() => {
                      if (open) close();
                    }}
                  >
                    <PopoverButton className="text-sm/6 font-bold text-gray-900 hover:text-gray-500 focus:outline-none">
                      <Link to="/locations">
                        LOCATIONS
                      </Link>
                    </PopoverButton>
                    <PopoverPanel className="absolute left-0 top-full z-10 w-40 pt-2">
                      <div className="rounded-md bg-white p-2 shadow-lg ring-1 ring-gray-900/5">
                        <HashLink smooth to="/locations#Wilmington" className="block px-3 py-2 text-sm text-gray-900 hover:bg-gray-50 rounded">Wilmington</HashLink>
                        <HashLink smooth to="/locations#Charlotte" className="block px-3 py-2 text-sm text-gray-900 hover:bg-gray-50 rounded">Charlotte</HashLink>
                      </div>
                    </PopoverPanel>
                  </div>
                )}
              </Popover>
              <HashLink
                smooth
                to="/#FreeQuote"
                className="text-sm/6 font-bold text-gray-900 hover:text-gray-500"
              >
                CONTACT
              </HashLink>
            </div>
          </nav>
        </div>
      </div>
      <Dialog
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
        className="lg:hidden"
      >
        <div className="fixed inset-0 z-50" />
        <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">HighTide Roofing</span>
              <img alt="HighTide Roofing" src={logo} className="h-8 w-auto" />
            </Link>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="size-6" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <Link
                    key={item.subName}
                    to={item.to}
                    onClick={() => setMobileMenuOpen(false)}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-bold text-gray-900 hover:bg-gray-50"
                  >
                    {item.subName}
                  </Link>
                ))}
                <Disclosure as="div" className="-mx-3">
                  <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base/7 font-bold text-gray-900 hover:bg-gray-50">
                    Locations
                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-[open]:rotate-180 transition-transform" />
                  </DisclosureButton>
                  <DisclosurePanel className="mt-2 space-y-2">
                    <HashLink
                      smooth
                      to="/locations#Wilmington"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block rounded-lg py-2 pl-6 pr-3 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                    >
                      Wilmington
                    </HashLink>
                    <HashLink
                      smooth
                      to="/locations#Charlotte"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block rounded-lg py-2 pl-6 pr-3 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                    >
                      Charlotte
                    </HashLink>
                  </DisclosurePanel>
                </Disclosure>
                <HashLink
                  smooth
                  to="/#FreeQuote"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-bold text-gray-900 hover:bg-gray-50"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Contact
                </HashLink>
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  );
}
